module.exports = __webpack_public_path__ + "ff0d5f546af13b4cccce92cf404e0aa4.jpg";